import React from 'react';
import AnimatedText from '../Components/animation/text/AnimatedText';
import SkillBadge from '../Components/SkillBadge';

const programming = ["C/C++", "Java", "Python", "JavaScript", "TypeScript", "Dart", "PostgreSQL", "Git"]
const frameworksOrLibraries = ["Spring Boot", "React", "Three.js", "Flutter", "Node.js", "Express", "Quarkus", "Tailwind CSS"]
const languages = ["Portuguese", "English", "Spanish", "Italian"]

const Skills = () => {
    return (
        <div id="skills" className="w-full flex flex-col items-center justify-center overflow-hidden mt-10">
            <div className="w-full xl:w-[70%] flex flex-row pb-16">
                <div className="w-full">
                    <AnimatedText text="Skills" />

                    <p className="text-secondary-400 text-[18px] mt-5 ml-12">
                        Skills are incredibly valuable, don't you think? Here are a few of the <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700"> skills I have:</span>

                    </p>
                    <p className="text-secondary-400 text-[18px] mt-4 ml-[5em]">
                        &gt; <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700 "> Programming: </span> {programming.map((skill, index) => (
                            <SkillBadge key={`${index}`} skill={skill} />
                        ))}
                    </p>

                    <p className="text-secondary-400 text-[18px] mt-4 ml-[5em]">
                        &gt; <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700"> Frameworks/Libraries: </span> {frameworksOrLibraries.map((skill, index) => (
                            <SkillBadge key={`${index}`} skill={skill} />
                        ))}
                    </p>

                    <p className="text-secondary-400 text-[18px] mt-4 ml-[5em]">
                        &gt; <span className="font-bold bg-clip-text bg-gradient-to-tr from-pink-600 to-purple-700"> Languages: </span> {languages.map((skill, index) => (
                            <SkillBadge key={`${index}`} skill={skill} />
                        ))}
                    </p>

                </div>

            </div>

        </div>
    )
};

export default Skills;
